import { AccountPlan, Subscription } from '@/constants/enum';
import { ITrialInfo } from '@/types/dashboard';
import { IRangeQuota, sortedPlansByTier } from '../../config';

export const getRecommendedPlanByQuota = (
  quotaRange: Record<AccountPlan, IRangeQuota>,
  totalQuota: number,
): AccountPlan | undefined => {
  return Object.entries(quotaRange).find(([_, range]) => totalQuota >= range.min && totalQuota <= range.max)?.[0] as AccountPlan;
};

export const checkIsHigherTierPlan = (
  quotaRange: Record<AccountPlan, IRangeQuota>,
  totalQuota: number,
  inputPlan: AccountPlan,
): boolean => {
  const planByQuotaRange = getRecommendedPlanByQuota(quotaRange, totalQuota);
  const targetIndex = sortedPlansByTier.indexOf(planByQuotaRange || AccountPlan.Starter);
  const inputIndex = sortedPlansByTier.indexOf(inputPlan);

  if (inputPlan === AccountPlan.Starter) {
    return true;
  }

  return inputIndex !== -1 && targetIndex !== -1 && inputIndex >= targetIndex;
};

export const getChoosePlanLabel = (trialInfo: ITrialInfo | undefined, plan: AccountPlan, subscription: Subscription): string => {
  const defaultLabel = 'Choose plan';
  const grantDays = trialInfo?.grantDaysByPlan[plan]?.[subscription];
  if (!trialInfo || grantDays === undefined) return defaultLabel;

  if (trialInfo.state === 'fresh' && grantDays > 0) return `Start ${grantDays}-day free trial`;
  if (trialInfo.state === 'mid_trial' && trialInfo.daysLeft > 0) {
    return `${defaultLabel} — ${trialInfo.daysLeft} ${trialInfo.daysLeft === 1 ? 'day' : 'days'} trial left`;
  }
  return defaultLabel;
};
